export default "__VITE_ASSET__B5Gw3OcU__"